import React, { useCallback, useEffect } from "react";
import axios from "axios"
import semver from "semver";
import UpdatePackage from "./UpdatePackage";
import Loader from "./Loader";


const states = {
    INIT: 1,
    UPDATING: 2,
    UPDATED: 3,
};

const EnableAutoUpdate = ({ session, onSuccess }) => {

    const [installedPackages, setInstalledPackages] = React.useState();
    const [viewState, setViewState] = React.useState(states.INIT);


    const printState = (state) => {
        const foundKey = Object.keys(states).find((k) => {
            return states[k] === state;
        });
        return foundKey;
    }



    const getPackages = async () => {
        return session.call("listPackages.dappmanager.dnp.dappnode.eth")
            .then(res => {
                res = JSON.parse(res);
                if (!res || !res.result) {
                    throw new Error(`cannot find any packages on your AVADO`);
                }
                return (res.result);
            })
            .catch((e) => {
                console.log(`${e.messsage}`);
                return null;
            });
    };

    React.useEffect(() => {
        console.log("starting EnableAutoUpdate component")
        if (session) {
            // console.log("I have a session");
            getPackages().then(setInstalledPackages);
        }
    }, [session]);

    React.useEffect(() => {

        const transitionTo = (newState) => {
            console.log(`EnableAutoUpdate: going from state  ${printState(viewState)} to ${printState(newState)}`);
            if (viewState === newState) {
                console.log(`from and to state are the same`);
                return;
            }
            switch (newState) {
                case states.UPDATING:
                    if (viewState === states.FETCHPACKAGES)
                        setViewState(newState);
                    break;
                case states.UPDATED:
                    if ([states.FETCHPACKAGES, states.UPDATING].includes(viewState)) {
                        setViewState(newState);
                    }
                    break;
                default:
                    console.log("unknown target state");
            }
        };

        if (installedPackages) {
            transitionTo(states.UPDATING);
            const corePackages = installedPackages.filter((p) => {
                return (p.isCore);
            })

            console.log(`packages to auto-update`, corePackages);

            corePackages.map(async (p)=>{
                await session.call("setAutoUpdate.dappmanager.dnp.dappnode.eth", [], {
                    id: p.name,
                    autoUpdate: true
                })
            })
            console.log("All done updating packages")
            transitionTo(states.UPDATED);
            onSuccess();
        }
    }, [installedPackages]);

    if (viewState === states.INIT) {
        return (<div>Fetching core packages<Loader /></div>);
    }
    if (viewState === states.UPDATING) {
        return (<div>Enabling auto-updates on core packages<Loader /></div>);
    }

    if (viewState === states.UPDATED) {
        return (<div>Everything updated</div>);
    }
}

export default EnableAutoUpdate;
